import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const transactionsCheckApi = createApi({
  reducerPath: 'transactionsCheckApi',
  tagTypes: ['DepositCheck', 'WithdrawCheck'],
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('token');
      if (token) {
        headers.set('X-Token', token);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    checkDeposit: builder.mutation({
      query: ({ user_id, start, end }) => {
        let url = `/admin/deposit-check?user_id=${user_id}`;
        if (start) {
          url += `&start=${start}`;
        }
        if (end) {
          url += `&end=${end}`;
        }
        return {
          url,
          method: 'GET',
        };
      },
      invalidatesTags: ['DepositCheck'],
    }),
    checkWithdraw: builder.mutation({
      query: ({ user_id }) => ({
        url: `/admin/withdraw-check?user_id=${user_id}`,
        method: 'GET',
      }),
      invalidatesTags: ['WithdrawCheck'],
    }),
  }),
});

export const {
  useCheckDepositMutation,
  useCheckWithdrawMutation,
} = transactionsCheckApi;